import React from 'react';
import PropTypes from 'prop-types';
import {
    connect,
} from 'react-redux';
import {
    Modal,
    Button,
    Form,
    Image,
} from 'react-bootstrap';
import ContactDetails from '../../shared/components/ContactDetails';
import actions from '@shared/actions';
import {
    language,
} from '@shared/language';

const i18n = {
    de: {
        accept_label: 'Bestätigen',
        cancel_label: 'Abbrechen',

        form_password_placeholder: 'Passwort',
    },
    en: {
        accept_label: 'Confirm',
        cancel_label: 'Cancel',

        form_password_placeholder: 'Password',
    },
};

class StandardDialog extends React.Component {

    static propTypes = {
        tour: PropTypes.any,
        show: PropTypes.bool.isRequired,
        config: PropTypes.any,
        container: PropTypes.any,
        dialogAccept: PropTypes.func.isRequired,
        dialogCancel: PropTypes.func.isRequired,
        dialogExited: PropTypes.func.isRequired,
    }

    state = {}

    passwordRef = React.createRef();

    componentDidUpdate(oldProps) {
        if (oldProps.show !== this.props.show && this.props.show) {
            setTimeout(() => { if (this.passwordRef.current) {this.passwordRef.current.focus()} }, 0);
            this.setState({
                password: undefined,
            });
        }
    }

    onPasswordChanged = (ev) => {
        this.setState({password: ev.target.value});
    }

    onAccept = () => {
        const config = this.props.config;
        if (config && config.accept && config.accept.createAction) {
            this.props.dialogAccept({
                action: config.accept.createAction(this.state),
            });
        } else {
            this.props.dialogAccept({});
        }
    }

    onCancel = () => {
        this.props.dialogCancel({});
    }

    onExited = () => {
        this.props.dialogExited();
    }

    render() {
        const {
            tour,
            show,
            config,
        } = this.props;

        if (!config) {
            return null;
        }

        let acceptVariant = 'primary';
        if (config.accept && config.accept.variant) {
            acceptVariant = config.accept.variant;
        }
        let acceptLabel = i18n[language].accept_label;
        if (config.accept && config.accept.label) {
            acceptLabel = config.accept.label;
        }

        let cancelVariant = 'secondary';
        if (config.cancel && config.cancel.variant) {
            cancelVariant = config.cancel.variant;
        }
        let cancelLabel = i18n[language].cancel_label;
        if (config.cancel && config.cancel.label) {
            cancelLabel = config.cancel.label;
        }

        const previewPath = tour && tour.get('preview') ? tour.get('preview') : false;
        const visitCard = <ContactDetails
            className={`my-2 greeter-visit-card`}
            contact={tour.get('contact')}
        />;

        return (
            <Modal
                className={config.greeting ? "greeter-dialog" : ""}
                show={show}
                onHide={this.onCancel}
                onExited={this.onExited}
                backdrop={config.noHide ? 'static' : undefined}
                centered
                container={this.props.container}
            >
                {!config.noHeader &&
                    <Modal.Header closeButton={!config.noCloseButton}>
                        <Modal.Title>{config.title}</Modal.Title>
                    </Modal.Header>
                }
                <Modal.Body>
                    {config.message &&
                        <p>
                            {config.message}
                        </p>
                    }

                    {config.greeting &&
                        <div>
                            {visitCard}
                            {previewPath &&
                                <Image
                                    src={previewPath}
                                    fluid
                                    onClick={this.onCancel}
                                />
                            }
                        </div>
                    }

                    {config.enterPassword &&
                        <Form.Group>
                            {config.enterPassword.label &&
                                <Form.Label for="enter-password">{config.enterPassword.label}</Form.Label>
                            }
                            <Form.Control
                                id="enter-password"
                                type="password"
                                ref={this.passwordRef}
                                value={this.state.password || config.enterPassword.value || ''}
                                placeholder={config.enterPassword.placeholder || i18n[language].form_password_placeholder}
                                onChange={this.onPasswordChanged}
                                onKeyUp={(ev) => {
                                    if (ev.keyCode === 13) {
                                        ev.preventDefault();
                                        this.onAccept();
                                    }
                                }}
                            />
                        </Form.Group>
                    }
                </Modal.Body>
                {!config.noFooter ? (
                    <Modal.Footer>
                        {!config.noCancelButton &&
                            <Button
                                className="float-left"
                                variant={cancelVariant}
                                onClick={this.onCancel}
                            >
                                {cancelLabel}
                            </Button>
                        }
                        {!config.noAcceptButton &&
                            <Button
                                className="float-right"
                                variant={acceptVariant}
                                onClick={this.onAccept}
                            >
                                {acceptLabel}
                            </Button>
                        }
                    </Modal.Footer>
                ) : (
                    <Modal.Footer
                            className="color-footer"
                            style={{backgroundColor: tour.get('primaryColor')}}>
                    </Modal.Footer>
                )
                }
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        show: state.dialog.getIn(['standard', 'show']),
        config: state.dialog.getIn(['standard', 'config']),
    };
}

const mapDispatchToProps = dispatch => {
    return {
        dialogAccept: (...args) => dispatch(actions.dialog.standard.accept(...args)),
        dialogCancel: (...args) => dispatch(actions.dialog.standard.cancel(...args)),
        dialogExited: () => dispatch(actions.dialog.standard.hidden()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StandardDialog);

